import {useCallback} from "react";
import {OnSaveTaskSingleVoyage} from "@containers/singleVoyage/tasks/table/types/events";
import {ITaskCreationSingleVoyageMutateVoyage} from "@containers/singleVoyage/mutateVoyage/tasks/types";
import {getRandomNumber} from "@helpers/number/getRandomNumber";
import {
    useGetTaskConfigByIdSingleVoyage
} from "@containers/singleVoyage/taskTemplate/hooks/useGetTaskConfigByIdSingleVoyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";

export function useSaveTaskMutateSingleVoyage({
                                                  accountId
                                              }: {
    accountId: string | number
}): {
    onSaveTask: OnSaveTaskSingleVoyage,
    isFetching: boolean,
    isLoading: boolean,
} {

    const {
        isFetching,
        isLoading,
        getTaskConfigById
    } = useGetTaskConfigByIdSingleVoyage({
        accountId,
    })

    const {
        setTasks,
        setTasksLocalCreateIds,
    } = useRootContextMutateSingleVoyage()


    const onSaveTask: OnSaveTaskSingleVoyage = useCallback(async ({
                                                                      task,
                                                                      closeModalFn,
                                                                  }) => {
        // The config comes from the TEMPLATE, not from the task's own id - otherwise
        // photoRequired and waypointLimit always fell back to defaults.
        const currentConfig = getTaskConfigById(task.taskConfigTemplateId)
        const newTask: ITaskCreationSingleVoyageMutateVoyage = {
            ...task,
            config: {
                photoRequired: currentConfig?.config?.photoRequired || 'NO',
                waypointLimit: currentConfig?.config?.waypointLimit || 'SINGLE',
                taskDetailsType: currentConfig?.config?.taskDetailsType || 'BASIC',
            }

        }
        if ('id' in task && task.id) {
            setTasks((prev) => {
                return prev.map((oldTask) => {
                    if (task.id.toString() === oldTask.id?.toString()) {
                        return {
                            ...newTask,
                        }
                    }
                    return oldTask
                })
            })
            closeModalFn && closeModalFn()
            return
        }
        const taskId = getRandomNumber()
        setTasksLocalCreateIds((prev) => {
            return [
                ...prev,
                taskId,
            ]
        })
        setTasks((prev) => {
            return [...prev, {
                ...newTask,
                id: taskId,

            }]
        })
        closeModalFn && closeModalFn()
    }, [])

    return {
        isFetching,
        isLoading,
        onSaveTask,

    }
}
